const commonAndMisc = {
  errorMessage404: "Hoppla! Die gesuchte Seite existiert nicht", // translated
  backToHome: "Zurück nach Hause", // translated
  information: "Information", // translated
  additionalInformation: "Weitere Informationen", // translated
  destinationPlaceholder: "Wohin gehst du", // translated
  aboutUs: "Über uns", // translated
  pleaseWait: "Warten Sie mal...", // translated
  featuredHotels: "Ausgewählte Hotels", // translated
  topPackages: "Top-Pakete", // translated
  topTours: "Top-Touren", // translated
  traveller: "Reisender", // translated
  reviews: "Bewertungen", // translated
  home: "Heim", // translated
  packages: "Pakete", // translated
  experiences: "Erfahrungen", // translated
  close: "Schließen", // translated
  loadingMessage: "Bitte warten Sie, während wir nach den besten verfügbaren Preisen suchen", // translated
  loadingMessageTheHotelCo: "Bitte warten Sie, während wir nach den besten verfügbaren Preisen suchen", // translated
  loadingMessageSearchStrip: "Bitte warten Sie, während wir nach den besten verfügbaren Preisen suchen...", // translated

  stillSearchingHotels:
    "Still searching — {{priced}} of {{discovered}} hotels priced",
  hotelsProgressCount: "Found {{priced}} of {{discovered}} hotels",
  searchingSuppliers: "Checking {{suppliers}}",
  topCountriesToVisit: "Top Länder zu besuchen", // translated
  profile: "Profil", // translated // translated 
  reservations: "Reservierungen", // translated
  address: "Die Anschrift", // translated
  firstName: "Vorname", // translated
  lastName: "Familienname, Nachname", // translated
  email: "Email", // translated
  login: "Anmeldung", // translated
  logout: "Ausloggen", // translated
  myProfile: "Mein Profil", // translated
  myChatRooms: "Meine Chats", // translated 
  chatRoomsListEmpty: "Für dieses Konto sind keine Chaträume verfügbar.", // translated 
  chatRoomsOpen: "Offen", // translated 
  chatRoomsLastActivity: "Letzte Aktivität", // translated 
  chatRoomsUnread: "Ungelesen", // translated 
  chatRoomsBadgeQuotation: "Angebot", // translated 
  chatRoomsBadgeTripOffer: "Reiseangebot", // translated 
  chatRoomsOpenQuotationAria: "Angebots-Chat öffnen: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "Chat für offene Reiseangebote: {{name}}", // translated 
  chatRoomsOpenGenericAria: "Offener Chat: {{name}}", // translated 
  quotationChatInvalidLink:
    "Ungültiger Chat-Link. Öffnen Sie einen Chat über Ihr Profil oder die Angebotsliste, oder verwenden Sie genau einen von room_code oder room_uid.", // translated 
  quotationChatNoTripDetails: "Reisedetails sind für diesen Chat nicht verfügbar.", // translated 
  chat: "Chat", // translated 
  verified: "Verifiziert", // translated
  unverified: "Unbestätigt", // translated
  selectLanguage: "Sprache auswählen", // translated
  selectCurrency: "Währung wählen", // translated
  upgrade: "Aktualisierung", // translated
  membership: "Mitgliedschaft", // translated
  travelTrust: "Reisevertrauen", // translated
  signInUp: "Anmelden/anmelden", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates: "weltweite Hotels und Resorts zu erstaunlichen Großhandelspreisen", // translated
  dashboard: "Armaturenbrett", // translated
  pricing: "Preisgestaltung", // translated
  refundable: "Erstattungsfähig", // translated
  cars: "Autos", // translated
  cruises: "Kreuzfahrten", // translated
  view: "Sicht", // translated
  price: "Preis", // translated
  totalPrice: "Gesamtpreis", // translated
  filterRoomName: "Raumname filtern", // translated
  get: "Werden", // translated
  guestInformationValidation: "Überprüfung der Gästeinformationen", // translated
  reservation: "Reservierung", // translated
  checkIn: "Check-In", // translated
  checkOut: "Kasse", // translated
  paymentInitiattionErroeMessage: "Wir konnten Ihren Zahlungsvorgang nicht einleiten. Wir entschuldigen uns für die Unannehmlichkeiten", // translated
  warning: "Warnung", // translated
  couldNotFindPriceForDateWarning: "Wir konnten für dieses Datum keinen Preis finden. Bitte versuchen Sie es an einem anderen Datum erneut", // translated
  searchFormValidationError: "Validierungsfehler des Suchformulars", // translated
  pleaseSelectValidDateFirst: "Bitte wählen Sie zuerst ein gültiges Datum aus", // translated
  searchError: "Suchfehler", // translated
  priceSearchInitiationError: "Wir konnten die Preissuche nicht starten. Bitte versuchen Sie es später erneut. Wir entschuldigen uns für die Unannehmlichkeiten", // translated
  searchWarning: "Suche Warnung", // translated
  couldNotFindPriceAndOrAvailability: "Wir konnten den Preis und/oder die Verfügbarkeit für Ihre Anfrage nicht finden. Wir entschuldigen uns für die Unannehmlichkeiten", // translated
  joinNow: "Jetzt beitreten", // translated
  signIn: "Anmelden", // translated
  searchNow: "Jetzt suchen", // translated
  bookingFailed: "Buchung fehlgeschlagen", // translated
  sorryForTheInconvenience: "Wir entschuldigen uns für die Unannehmlichkeiten", // translated
  paymentFailedTryAgain: "Bezahlung fehlgeschlagen. Bitte versuche es erneut", // translated
  quickLinks: "Schnelle Links", // translated
  tours: "Touren", // translated
  termsAndConditions: "Geschäftsbedingungen", // translated
  pleaseWaitWhileInitiatingPayment: "Bitte warten Sie, während wir Ihren Zahlungsvorgang einleiten", // translated
  back: "Zurück", // translated
  nextStep: "Nächster Schritt", // translated
  book: "Buch", // translated
  checkout: "Kasse", // translated
  specifyPickUpPoint: "Geben Sie den Ort Ihrer bevorzugten Abholung an", // translated
  pickupPoint: "Abholpunkt", // translated
  optional: "Optional", // translated
  remarks: "Bemerkungen", // translated
  travellerInformation: "Informationen für Reisende", // translated
  bookingRemarks: "Bemerkungen zur Buchung", // translated
  bookingOverview: "Buchungsübersicht", // translated
  paymentFailed: "Bezahlung fehlgeschlagen", // translated
  paymentSuccess: "Zahlungserfolg", // translated
  at: "Beim", // translated
  person: "Person", // translated
  cancellationPolicy: "Stornierungsbedingungen", // translated
  From: "Aus", // translated
  to: "zu", // translated
  cancellationIs: "Stornierung ist", // translated
  pickup: "Aufsammeln", // translated
  flights: "Flüge", // translated
  Accommodation: "Unterkunft", // translated
  payAndBook: "Zahlen & Buchen", // translated
  onRequest: "Auf Anfrage", // translated
  weAreFindingTheBestAvailableServices: "Wir finden die besten verfügbaren Dienste", // translated
  withTheBestAvailablePrices: "mit den besten verfügbaren Preisen", // translated
  inRealTime: "in Echtzeit", // translated
  seconds: "Sekunden", // translated // translated 
  thisProcessCanTakeUpToOneMinute: "Dieser Vorgang kann bis zu 1 Minute dauern", // translated
  pleaseDoNotRefreshThisPage: "Bitte aktualisieren Sie diese Seite nicht", // translated
  wellItSeemsItCanTakeBitLonger: "Nun... es scheint, dass es etwas länger dauern kann", // translated
  yourBrowserDoesNotSupportTheVideoTag: "Ihr Browser unterstützt das Video-Tag nicht", // translated
  bookingSuccess: "Buchungserfolg", // translated
  bookingReference: "Buchungsreferenz", // translated
  referenceCopied: "Referenz kopiert", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation: "In Kürze erhalten Sie eine E-Mail mit allen erforderlichen Informationen für Ihre Reservierung", // translated
  viewMore: "Mehr sehen", // translated
  readMore: "Weiterlesen", // translated
  customerSupport: "Kundendienst", // translated
  socialMedia: "Sozialen Medien", // translated
  emailIsRequired: "E-Mail ist erforderlich", // translated
  score: "Punktzahl", // translated
  phoneNumberInTheFormat: "Die Telefonnummer muss im Format ohne Leerzeichen vorliegen", // translated
  active: "Aktiv", // translated
  nearby: "Nahe", // translated
  currency: "Währung", // translated
  countryIsRequired: "Land ist erforderlich", // translated
  sendVoucherEmail: "Gutschein-E-Mail senden", // translated
  km: "km", // translated
  minute: "Minute", // translated // translated 
  phoneNumberIsRequired: "Telefonnummer ist erforderlich", // translated
  cityIsRequired: "Stadt ist erforderlich", // translated
  postalCodeIsRequired: "Postleitzahl ist erforderlich", // translated
  genderIsRequired: "Geschlecht ist erforderlich", // translated
  confirmed: "Bestätigt", // translated
  lastNameIsRequired: "Nachname ist erforderlich", // translated
  notAvailable: "Nicht verfügbar", // translated
  pleaseCheckTheBox: "Bitte markieren Sie das Kästchen, um zu bestätigen, dass Sie die bereitgestellten Informationen gelesen haben und damit einverstanden sind, bevor Sie mit dem nächsten Schritt fortfahren.", // translated
  noOptionsForSelectedFilters: "Es sind keine Optionen zum Anpassen Ihrer Filter verfügbar", // translated
  noReservationsForThisProduct: "Für dieses Produkt liegen keine Reservierungen vor", // translated
  security: "Sicherheit", // translated
  sendCancellationEmail: "Stornierungs-E-Mail senden", // translated
  hours: "Std.", // translated
  memberId: "Mitgliedsnummer", // translated
  firstNameMustContainAlphabetic: "Der Vorname darf nur alphabetische Zeichen enthalten", // translated
  visitSite: "Besucherseite", // translated
  star: "Stern", // translated
  leadGuest: "Hauptgast", // translated
  cancelled: "Abgesagt", // translated
  applicationAvailable: "Anwendung verfügbar", // translated
  sendUsRequest: "Senden Sie uns Ihre Anfrage", // translated
  clickHere: "klicken Sie hier", // translated
  downloadVoucher: "Gutschein herunterladen", // translated
  errorContentUnavailable: "Ups! Der gesuchte Inhalt existiert nicht. Bitte kontaktieren Sie uns bezüglich des Problems", // translated
  titleIsRequired: "Titel ist erforderlich", // translated
  status: "Status", // translated // translated 
  clearYourFilters: "Bitte löschen Sie Ihre Filteroptionen, um Ergebnisse anzuzeigen", // translated
  firstNameIsRequired: "Vorname ist erforderlich", // translated
  distanceFromSelection: "Abstand zur Auswahl", // translated
  progressAt: "Fortschritt bei", // translated
  sendUsEmail: "Senden Sie uns eine Email", // translated
  invalidEmail: "Ungültige E-Mail", // translated
  proceed: "Fortfahren", // translated
  reference: "Referenz", // translated
  hour: "Stunde", // translated // translated 
  emailNotSentTryAgain: "E-Mail nicht gesendet! Bitte versuche es erneut", // translated
  minutes: "Protokoll", // translated
  pending: "Ausstehend", // translated
  restaurants: "Restaurants", // translated
  sendUsYourRequest: "Senden Sie uns Ihre Anfrage", // translated
  stars: "Sterne", // translated
  addressIsRequired: "Adresse ist erforderlich", // translated
  lastNameMustContainAlphabetic: "Der Nachname darf nur alphabetische Zeichen enthalten", // translated
  yourReservationIsInProgress: "Ihre Reservierung ist in Bearbeitung", // translated
  clearAllFilters: "Alle Filter löschen", // translated
  privacyPolicy: "Datenschutzrichtlinie", // translated
  emailHasBeenSent: "E-Mail erfolgreich gesendet", // translated
  iHaveReadAgreeWithAbove: "Ich habe das oben Gesagte gelesen und bin damit einverstanden", // translated
  found: "Gefunden", // translated
  maintenanceTitle: "Website wird gewartet", // translated 
  maintenanceDescription:
    "Wir führen planmäßige Wartungsarbeiten durch. Bitte versuchen Sie es später erneut.", // translated 
  maintenanceCountdownLabel: "Voraussichtliche verbleibende Zeit", // translated 
  maintenanceLogoAlt: "Website-Logo", // translated 
  maintenanceDays: "Tage", // translated 
  maintenanceHours: "Stunden", // translated 
  maintenanceMinutes: "Minuten", // translated 
  maintenanceSeconds: "Sekunden", // translated 
  maintenanceStatusBadge: "Geplante Wartung", // translated 
  maintenanceRefresh: "Seite aktualisieren", // translated 
  maintenanceExpired:
    "Die Wartung sollte in Kürze abgeschlossen sein. Bitte aktualisieren Sie die Seite.", // translated 
};


export default commonAndMisc;
